import useAvailableTags from 'hooks/data/dashboards/useAvailableTags';
import { createContext, PropsWithChildren, useContext } from 'react';

export type FundTypeSelectorOption = {
  name: string;
  key: string;
  tagId: string;
};

type FundTypeSelectorOptionsContext = {
  options: Array<FundTypeSelectorOption>;
};

const defaultState: FundTypeSelectorOptionsContext = {
  options: [],
};

const FundTypeSelectorOptionsContext =
  createContext<FundTypeSelectorOptionsContext>(defaultState);

export const useFundTypeSelectorOptionsContext = () => {
  const state = useContext(FundTypeSelectorOptionsContext);
  if (!state)
    throw new Error('Fund type selector context used outside provider');

  return state;
};

type ContextProviderProps = {
  firmId?: string;
};

export const FundTypeSelectorOptionsContextProvider: React.FC<
  PropsWithChildren<ContextProviderProps>
> = ({ children, firmId }) => {
  const availableTags = useAvailableTags({ firmId });
  const options = availableTags.data ?? [];

  const state: FundTypeSelectorOptionsContext = { ...defaultState, options };

  return (
    <FundTypeSelectorOptionsContext.Provider value={state}>
      {children}
    </FundTypeSelectorOptionsContext.Provider>
  );
};
